import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
import { typography } from '@domain-group/fe-co-allhomes-design-system';
import * as common from '../common.style';
var colour = variables.colour,
  font = variables.font;
var _ref = {
  name: "vdhlfv",
  styles: "cursor:not-allowed;"
};
export var auctionCard = isEnabled => /*#__PURE__*/css("padding:12px;background:", isEnabled ? colour.white : colour.neutral50, ";", !isEnabled && _ref);
export var link = isEnabled => /*#__PURE__*/css("color:", isEnabled ? colour.neutral700 : colour.neutral500, ";text-decoration:none;&::before,&::after{content:'';display:table;}&::after{clear:both;}");
export var detailsBody = {
  name: "1hswejy",
  styles: "display:block;overflow:hidden;"
};
export var detailsTop = {
  name: "1ymf3cs",
  styles: "display:table;width:100%;"
};
export var detailsBottom = {
  name: "1ymf3cs",
  styles: "display:table;width:100%;"
};
export var image = /*#__PURE__*/css("float:left;width:88px;height:64px;margin-right:16px;.img-wide{", common.imgWide, "}.img-wide-placeholder{", common.imgWidePlaceholder, "}");
export var price = /*#__PURE__*/css("display:table-cell;width:1px;text-align:right;white-space:nowrap;", typography.desktopHeadingM, ";");
export var address = isEnabled => /*#__PURE__*/css("display:table-cell;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;max-width:80px;padding-right:15px;padding-top:0;", typography.desktopHeadingM, ";", !isEnabled && /*#__PURE__*/css("color:", colour.neutral500, ";"));
export var features = /*#__PURE__*/css("display:inline-block;&-item{margin-right:14px;}&-item-value{font-family:", font.bodyFontFamily, ";display:inline-block;margin-bottom:1px;}&-item-icon-container{margin-left:6px;}&-item-icon{vertical-align:bottom;}");
export var propertyType = {
  name: "1baulvz",
  styles: "display:inline-block;"
};
export var pricePrefix = /*#__PURE__*/css("font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";font-weight:normal;margin-right:8px;");
export var detailsBottomLeft = {
  name: "1w2mkii",
  styles: "display:table-cell;white-space:nowrap;width:1px;"
};
export var auctionAgency = /*#__PURE__*/css("display:table-cell;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;max-width:80px;padding-left:15px;text-align:right;font-family:", font.bodyFontFamily, ";font-size:", font.baseFontSize, ";color:", colour.neutral400, ";");